import type { FaireProductEntity } from "../../entity_types/product";

export const p_2uknhr7z: FaireProductEntity = {
  token: "p_2uknhr7z",
  type: "product",
  name: "Piñon - 7.2 oz Standard Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/47c468b0d78622aa0011f2c3f986c36cc498fbc93a79141f1c65b2ea6ad9bde6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/db3340b7e8ea5a26b3d202a5f965e733beed1bc3ce3b4e1f774da4baeac94e94.jpeg",
    "https://cdn.faire.com/fastly/22545859923f52e741d1afdd8f7a764cf3452450772cd902ba0075448bf77f00.jpeg",
    "https://cdn.faire.com/fastly/5d1970dbe303a59d7b5d4e8ef734ce64b851e32dc9699b772bbfeef720f2a3d3.jpeg",
    "https://cdn.faire.com/fastly/684b102beb292a8c2e638fa6b79287989799edc67f2cadc7c36e8ea7a1d05877.jpeg",
    "https://cdn.faire.com/fastly/c759dda0d044a80b01fbeb2139253697c54d28a43f969447ee72db520a9d08ea.jpeg",
    "https://cdn.faire.com/fastly/c92432806d41e3d6f3c618531fde5312106f715a6cf03bbac99e6996e1de4217.jpeg",
  ],
  priceDollars: 11,
  description:
    "Winters in the Southwest, lingering bonfires, wool jackets in rotation. Notes of piñon logs, cedar, and vanilla.\n\nThis is our most popular size and is meant for dressers, countertops, nightstands – basically everywhere.\n\nOur 7.2 oz Standard Candles are hand-poured into apothecary inspired amber jars with our signature kraft label and a brass lid.\n\nOur candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for 40-50 hours.",
  tags: [],
  msrpDollars: 23.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:42.738Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
